import { TickerDelay } from "../tools/TickerDelay";
import { BundleResourcesLoader } from "./BundleResourcesLoader";

export class BundleResourcesLoaderWrapper extends BundleResourcesLoader {
    private static readonly MAX_ATTEMP_COUNT = 3;
    private static readonly ATTEMPS_DELAY_MS = 250;

    public override async load(): Promise<BundleResourcesLoader> {
        return await this.wrapLoad(() => super.load());
    }

    private async wrapLoad(loadFunc: () => Promise<BundleResourcesLoader>, attemp: number = 0): Promise<BundleResourcesLoader> {
        try {
            return await loadFunc();
        }
        catch (e: unknown) {
            if (attemp < BundleResourcesLoaderWrapper.MAX_ATTEMP_COUNT) {
                await TickerDelay.delay(BundleResourcesLoaderWrapper.ATTEMPS_DELAY_MS);
                return await this.wrapLoad(loadFunc, ++attemp);
            }
            throw e;
        }
    }
}